
import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Input} from 'reactstrap';

class SalesforcePushModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: true,
      value: '',
    };

    this.toggle = this.toggle.bind(this);
    this.submit = this.submit.bind(this);
  }

  toggle() {
    this.setState({
      active: !this.state.active
    });
  }

  handleChange(val){
    this.setState(({value}) => ({value: val}));
  }

  submit() {
    this.props.callback(this.state.value)

  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
        <ModalHeader toggle={this.props.toggle}>Push to Salesforce</ModalHeader>
        <ModalBody>
          Verification record ID: <Input value={this.state.value} onChange={(ref)=>this.handleChange(ref.target.value)}/>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" disabled={!this.state.value} onClick={this.submit}>Push</Button>{' '}
          <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default SalesforcePushModal;



// WEBPACK FOOTER //
// ./src/components/Verification/Actions/SalesforcePushModal.js